// extracted by mini-css-extract-plugin
module.exports = {"emptyFooterBar":"CreateFeedPage_emptyFooterBar__17zLo","container":"CreateFeedPage_container__Pi7KI"};